import React from 'react';
import PropTypes from 'prop-types';
import Divider from '../Divider';
import { init, getId } from '../../user-track-sdk';
import { ENV } from '../../config';
import './styles.scss';

export default class ServiceFooter extends React.Component {
  state = {
    code: ''
  }

  static propTypes = {
    showService: PropTypes.bool
  }

  static defaultProps = {
    showService: true
  }

  async componentDidMount() {
    await init({
      env: ENV === 'prod' ? 'prod' : 'test'
    });
    try {
      const code = await getId();
      this.setState({ code });
    } catch (error) {
      this.setState({ code: 'error' });
    }
  }

  render() {
    const { code } = this.state;
    const { showService } = this.props;
    return (
      <div className="component-service-footer">
        <span>
          服务代码：
          {code || 'loading...'}
        </span>
        {showService && (
          <React.Fragment>
            <Divider />
            <a href="/w/tool/">客服中心</a>
          </React.Fragment>
        )}
      </div>
    );
  }
}
